export default {
    headbar: {
        // Top buttons
        file: 'File',
        mode: 'Mode',
        layout: 'Layout',
        manualLayout: 'Manual Layout',
        fingeringAnnotation: 'Fingering',

        // File menu
        fileMenu: {
            importTxt: 'Import (.txt)',
            exportSvg: 'Export (.svg)',
            exportPdf: 'Export (.pdf)',
            exportTxt: 'Export (.txt)'
        },

        // Mode options
        modeOptions: {
            'piano-roll': 'Guqin Roll',
            'guitar-tablature': 'Guqin Tab'
        },

        // Settings dialog
        settings: {
            title: 'Score Settings',
            tabs: {
                page: 'Page',
                font: 'Font',
                roll: 'Roll',
                lines: 'Tab',
                lyrics: 'Lyrics',
                finger: 'Fingering'
            },
            page: {
                paperAndMargin: 'Paper & Margins',
                paperSize: 'Paper Size',
                selectPaper: 'Select Paper',
                marginSettings: 'Margins',
                margins: {
                    top: 'Top',
                    right: 'Right',
                    bottom: 'Bottom',
                    left: 'Left'
                },
                spacingSettings: 'Spacing',
                topSpacing: 'Score Top',
                lyricsSpacing: 'Lyrics Top',
                fingeringSpacing: 'Fingering Top'
            },
            common: {
                font: 'Font',
                size: 'Size',
                color: 'Color',
                style: 'Style',
                bold: 'Bold',
                italic: 'Italic',
                align: 'Alignment'
            },
            font: {
                titleStyle: 'Title Style',
                keyStyle: 'Key Style',
                options: {
                    default: 'Default',
                    songti: 'Song Ti',
                    heiti: 'Hei Ti',
                    kaiti: 'Kai Ti',
                    fangsong: 'Fang Song',
                    yuanti: 'Yuan Ti',
                    xingkai: 'Xing Kai',
                    calligraphy: 'Calligraphy'
                }
            },
            roll: {
                basic: 'Basic',
                appearance: 'Appearance',
                rollHeight: 'Roll Height',
                beatsPerLine: 'Beats/Line',
                rollColor1: 'Roll Color 1',
                rollColor2: 'Roll Color 2',
                noteStroke: 'Note Stroke',
                noteFill: 'Note Fill',
                triangleStroke: 'Triangle Stroke',
                triangleFill: 'Triangle Fill',
                positionColor: 'Hui Color',
                positionFont: 'Hui Font',
                noteCorner: 'Note Corner',
                cornerRounded: 'Rounded',
                cornerSquare: 'Square'
            },
            lines: {
                basic: 'Basic',
                appearance: 'Appearance',
                lineSpacing: 'Line Spacing',
                notesPerLine: 'Notes/Line',
                thickLine: 'Thick Line',
                thinLine: 'Thin Line',
                triangleStroke: 'Triangle Stroke',
                triangleFill: 'Triangle Fill',
                positionColor: 'Hui Color',
                positionFont: 'Hui Font'
            },
            lyrics: {
                style: 'Lyrics Style'
            },
            finger: {
                style: 'Fingering Style'
            },
            cancel: 'Cancel',
            save: 'Save',
            size: {
                small: 'Small',
                medium: 'Medium',
                large: 'Large'
            },
            align: {
                left: 'Left',
                center: 'Center',
                right: 'Right'
            },
            reset: 'Reset All',
            resetTitle: 'Confirm Reset',
            resetConfirm: 'Are you sure to reset all settings to default?',
            resetConfirmButton: 'Reset',
            resetCancelButton: 'Cancel',
            resetSuccess: 'Settings have been reset to default'
        },

        // Help dialog
        help: {
            title: 'Input Guidelines',
            structure: '1. Input Structure',
            inputRules: '2. Input Rules',
            rhythmSymbols: '3. Rhythm Symbols',
            lyricsRules: '4. Lyrics Rules',
            layoutModes: '5. Layout Modes',
            close: 'Close'
        },

        jianpuConverter: {
            title: 'Jianpu Converter',
            jianpuInput: 'Jianpu Input',
            jianpuPlaceholder: 'Please enter Jianpu numbers (e.g., 1 2, 3\' 4,, 5\'\' 6 7)',
            cancel: 'Cancel',
            convert: 'Convert'
        }
    },
    tablature: {
        key: 'Key',
        stringNo: 'StrNo'
    }
}